module.exports = __webpack_public_path__ + "img/sec13desk.1e9b944f.png";